import { render, staticRenderFns } from "./newNotices.vue?vue&type=template&id=aadeb3da&"
import script from "./newNotices.vue?vue&type=script&lang=js&"
export * from "./newNotices.vue?vue&type=script&lang=js&"
import style0 from "./newNotices.vue?vue&type=style&index=0&id=aadeb3da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports